import React from 'react';

import { isAdjustmentEventType } from 'components/pages/finance/NewInvoice/services/service';

import { Amount } from '../../../shared/amount-view/Amount/Amount';

export const AmountsSummary = ({
  currentInvoiceType,
  CMDMTotalAmount,
  generateWithholdingPDF,
  balanceDueWH,
  balanceDue,
  paymentsCredits
}) => {
  return (
    <div className="amount-calculation">
      {isAdjustmentEventType(currentInvoiceType) ? (
        <div>
          Total
          <Amount coinsAmount={CMDMTotalAmount} showDollarSign={true} />
        </div>
      ) : (
        <>
          <div data-testid="subtotal">
            Subtotal
            <Amount coinsAmount={generateWithholdingPDF ? balanceDueWH : balanceDue} showDollarSign={true} />
          </div>
          <div data-testid="less-payments">
            Payments / Credits
            <Amount coinsAmount={paymentsCredits} showDollarSign={true} />
          </div>
          <div data-testid="balance-due">
            Balance Due
            <Amount coinsAmount={generateWithholdingPDF ? balanceDueWH : balanceDue} showDollarSign={true} />
          </div>
        </>
      )}
    </div>
  );
};
